// extracted by mini-css-extract-plugin
module.exports = {"date":"Sold_date__jv93Q","soldDateContainer":"Sold_soldDateContainer___HZpt","buttonContainer":"Sold_buttonContainer__lC1Pl"};